//import './FileUpload.scss';

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Dropzone from 'react-dropzone';

import { apiFetch } from '../fetch/apiFetch';

export default class FileUpload extends React.Component {
  static defaultDescription = 'Select or drop a file here';

  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      uploadedFileUrl: null,
      uploadDescription: FileUpload.defaultDescription,
      showRemove: false,
    };
  }

  static defaultProps = {
    hideUploadAfterFile: false,
    isClearable: false,
    isPublic: false,
  };

  static propTypes = {
    onFileUploaded: PropTypes.func.isRequired,
    initialFileUrl: PropTypes.string,
    uploadDescription: PropTypes.string,
    hideUploadAfterFile: PropTypes.bool,
    acceptedFileTypes: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    isClearable: PropTypes.bool,
    isPublic: PropTypes.bool,
  };

  componentDidMount() {
    if (this.props.initialFileUrl) {
      this.setState({
        uploadedFileUrl: this.props.initialFileUrl,
        showRemove: true,
      });
    }
    if (this.props.uploadDescription) {
      this.setState({ uploadDescription: this.props.uploadDescription });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.initialFileUrl && this.props.initialFileUrl) {
      this.setState({
        uploadedFileUrl: this.props.initialFileUrl,
        showRemove: true,
      });
    }
  }

  upload = async (file) => {
    this.setState({ uploading: true });
    const data = new FormData();
    data.append('file', file);
    try {
      const json = await apiFetch('files/temp', 'POST', data, {
        contentType: null,
        stringifyContent: false,
        automaticSuccessNotification: false,
      }, this.props.isPublic);
      this.setState({
        uploading: false,
        uploadedFileUrl: json.url,
        showRemove: true,
      });
      this.props.onFileUploaded({
        key: json.key,
        url: json.url,
        name: file.name,
      });
    }
    catch {
      this.setState({
        uploading: false
      })
    }
  };

  onDrop = (files) => {
    if (files.length === 1) {
      const file = files[0];
      this.upload(file);
    }
  };

  handleOnRemove = (e) => {
    e.preventDefault();
    this.setState({
      uploadedFileUrl: null,
      uploadDescription: FileUpload.defaultDescription,
      showRemove: false,
    });

    this.props.onFileUploaded({ key: undefined, url: undefined });
  };

  render() {
    const { uploadedFileUrl, uploading, uploadDescription, showRemove } = this.state;
    const { hideUploadAfterFile, acceptedFileTypes, className, children, isClearable} = this.props;
    const showDropZone = !hideUploadAfterFile || !uploadedFileUrl;

    return (
      <Fragment>
        {showDropZone && (
          <Fragment>
            <Dropzone
              className={className}
              onDrop={this.onDrop}
              multiple={false}
              accept={acceptedFileTypes}
            >
              {uploading && (
                <span>
                  <i className="fa fa-spin fa-spinner" /> Uploading
                </span>
              )}
              {children && <div>{children}</div>}
              {!children && (
                <span className="upload-description">{uploadDescription}</span>
              )}
            </Dropzone>
            {isClearable && showRemove && (
              <i
                className="fa fa-times fa-lg text-danger p-2"
                onClick={this.handleOnRemove}
              />
            )}
          </Fragment>
        )}
        {!showDropZone && (
          <span className="text-primary">
            {children}
            {!children && uploadDescription}
            {showRemove && (
              <i
                className="fa fa-times fa-lg text-danger p-2"
                onClick={this.handleOnRemove}
              />
            )}
          </span>
        )}
      </Fragment>
    );
  }
}
